// frontend/src/components/common/SaveDiscardButtons.jsx
//
// The Save / Discard pair above a grid with inline-editable cells.
//
// One home for what every such pair must do: appear only once something is
// dirty, say how many rows or cells the save will send, spin on Save while
// the request runs, and lock Discard for the same stretch so the merchant
// cannot drop edits the server is still writing. A page passes only the
// count, the in-flight flag and the two handlers.

import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * @param {Object}   props
 * @param {number}   props.count     - dirty rows or cells; 0 renders nothing
 * @param {boolean}  props.saving    - the save request is in flight
 * @param {Function} props.onSave
 * @param {Function} props.onDiscard
 */
export default function SaveDiscardButtons({ count, saving, onSave, onDiscard }) {
  const { t } = useTranslation();
  if (count === 0) return null;
  return (
    <>
      <Button variant="contained" onClick={onSave} loading={saving}>
        {t('btn.saveChanges')} ({count})
      </Button>
      <Button variant="outlined" onClick={onDiscard} disabled={saving}>
        {t('btn.discardChanges')}
      </Button>
    </>
  );
}
